<script lang="ts" setup>
import { computed, ref } from 'vue';
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import NotificationMark from '@/components/notifications/notification-mark.vue';
import { useUnviewedNotifications } from '@/utils/composables/useUnviewedNotifications';
import { useStore } from '@/utils/vue';

const store = useStore();
const notificationButton = ref<HTMLButtonElement>();

const { hasUnviewedNotification } = useUnviewedNotifications();

/** 通知ポップアップの開閉状態 */
const isOpenNotificationPopup = computed(
  () => store.state.notificationPopup.isOpen,
);

const toggleNotificationPopup = () => {
  if (isOpenNotificationPopup.value) {
    store.commit('notificationPopup/close');
  } else {
    // 通知ボタンの相対位置からpopupの位置を決定する
    const rect = notificationButton.value?.getBoundingClientRect();
    if (!rect) return;
    store.commit('notificationPopup/show', {
      position: {
        top: `${rect.y + rect.height}px`,
        right: `${window.innerWidth - rect.x - rect.width}px`,
      },
    });
  }
};
</script>

<template>
  <button
    class="c-notification-button"
    v-tooltip.top="'通知'"
    ref="notificationButton"
    @click.stop="toggleNotificationPopup"
  >
    <DgrIcon name="bell" class="c-icon" />
    <NotificationMark
      v-if="hasUnviewedNotification"
      :right="'2px'"
      :top="'2px'"
    />
  </button>
</template>

<style lang="scss" scoped>
.c-notification-button {
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  border-radius: 4px;
  border: none;
  background-color: white;

  &:hover {
    background-color: $color-gray200;
  }

  .c-icon {
    width: 21px;
    height: 21px;
    margin: 5.5px;
  }
}
</style>
